import { TRANSFER_MESSAGE_TYPES } from "../localTransfer.constants";
import {
  buildReceivedFile,
  calculateTransferProgress,
  parseFileChunkMessage,
  parseTextMessage,
} from "./transferProtocol";

export const createIncomingTransfer = () => ({
  metadata: null,
  chunks: [],
  receivedBytes: 0,
});

const buildReceivedTransfer = ({ metadata, chunks }) => ({
  title: metadata?.title ?? "",
  content: metadata?.content ?? "",
  file: buildReceivedFile({ fileMetadata: metadata?.file, chunks }),
});

export const readReceiverTextMessage = ({ messageText, incomingTransfer }) => {
  const message = parseTextMessage(messageText);

  if (message.type === TRANSFER_MESSAGE_TYPES.NOTE_METADATA) {
    return { incomingTransfer: { ...createIncomingTransfer(), metadata: message } };
  }
  if (message.type === TRANSFER_MESSAGE_TYPES.TRANSFER_COMPLETE) {
    return { receivedTransfer: buildReceivedTransfer(incomingTransfer) };
  }
  if (message.type === TRANSFER_MESSAGE_TYPES.TRANSFER_ERROR) {
    return { errorMessage: message.errorMessage };
  }

  return {};
};

export const readReceiverFileChunk = ({ messageBuffer, incomingTransfer }) => {
  const { metadata, bytes } = parseFileChunkMessage(messageBuffer);
  const chunks = [...incomingTransfer.chunks];
  const receivedBytes = incomingTransfer.receivedBytes + bytes.byteLength;

  chunks[metadata.chunkIndex] = bytes;
  return {
    incomingTransfer: { ...incomingTransfer, chunks, receivedBytes },
    transferProgress: calculateTransferProgress({
      receivedBytes,
      totalBytes: incomingTransfer.metadata?.file?.size,
    }),
  };
};
